const TESTING_PLACE_ISUSE = {
  field: {
    unused: 0,
    used: 1,
    join: 2,
  },
  value: [0,1,2],
  name: {
    0: '사용불가',
    1: '사용중',
    2: '사용요청',
  },
};

module.exports = {
  TESTING_PLACE_ISUSE
};